import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import { translate } from 'react-i18next';

import WinkNotification from '../../../../../common/WinkNotification';

import TaxReceiptDashboardNotification_en from './locales/TaxReceiptDashboardNotification_en.json';
import TaxReceiptDashboardNotification_fr from './locales/TaxReceiptDashboardNotification_fr.json';

class DashboardNotification extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };

    i18next.addResourceBundle('en', 'TaxReceiptDashboardNotification', TaxReceiptDashboardNotification_en);
    i18next.addResourceBundle('fr', 'TaxReceiptDashboardNotification', TaxReceiptDashboardNotification_fr);
  }

  componentDidMount() {
    this.props.fetchTaxReceiptConfiguration()
      .then((configuration) => {
        this.setState({
          loaded: true,
        });
      })
      .catch((error) => {
        this.setState({
          loaded: true,
        });
      });
  }

  render() {
    const { props, state } = this;
    const { t, locale, roleId, configuration } = props;
    const { loaded } = state;

      if (!loaded) {
        return null;
      }

      const isConfigured = (configuration && configuration.logoId && configuration.prefix && configuration.signatureId && configuration.sequence );
      const automaticDonationReceipt = configuration && configuration.statusId === 1;
      const isAdmin = roleId === 1 || roleId === 3 || roleId === 4;

      const taxReceiptAdminNotification = !isConfigured && !automaticDonationReceipt && isAdmin && (
        <WinkNotification
          title={t('admin-new-donation-receipts-title')}
          description={t('admin-new-donation-receipts-description')}
          buttons={[<Button><Link to={`/${locale}/d/plugins/donationreceipt`}>{t('admin-new-donation-receipts-cta')}</Link></Button>]}
          alignButtons={'right'}
          closable={false}
        />
      );

      const taxReceiptUserNotification = isConfigured && !isAdmin && (
        <WinkNotification
          title={t('user-new-donation-receipts-title')}
          description={t('user-new-donation-receipts-description')}
          buttons={[<Button><Link to={`/${locale}/d/contributions/list/donations`}>{t('user-new-donation-receipts-cta')}</Link></Button>]}
          alignButtons={'right'}
          closable={false}
        />
      );

    return (
      <React.Fragment>
        {taxReceiptAdminNotification}
        {taxReceiptUserNotification}
      </React.Fragment>
    );
  }

}

export default translate('TaxReceiptDashboardNotification')(DashboardNotification);
